<div [matTooltip]="tooltip" [matTooltipDisabled]="!hasTooltip">
  <button matButton (click)="action.emit()" [disabled]="disabled">
    <mat-icon>chevron_left</mat-icon>
    <ng-content></ng-content>
  </button>
</div>
